import React, {useEffect, useState} from 'react';
import {Link} from "gatsby";
import classNames from "classnames";
import * as s from './styles.module.css';
import PreferencesModal from "./PreferencesModal";
import {path} from "../../../utils/path";
import {acceptAll, onOpenPreferences, rejectAll, setConsent, useConsent} from "../../../utils/consent";

const CookieConsent = () => {
    const {consent, decided, ready} = useConsent();
    const [showPreferences, setShowPreferences] = useState(false);

    useEffect(() => onOpenPreferences(() => setShowPreferences(true)), []);

    // `ready` is false during SSR and the first client render, so the banner never
    // ends up in the static HTML and hydration stays in sync.
    if (!ready) return null;

    const closePreferences = () => setShowPreferences(false);

    const handleSave = (draft) => {
        setConsent(draft);
        closePreferences();
    };

    const handleAcceptAll = () => {
        acceptAll();
        closePreferences();
    };

    const handleRejectAll = () => {
        rejectAll();
        closePreferences();
    };

    return (
        <>
            {!decided && (
                <div className={s.banner} role="dialog" aria-live="polite" aria-label="Cookie consent">
                    <p className={s.copy}>
                        We use cookies to run this site and, with your permission, to measure how it is used.
                        Blocking cookies may prevent some site services from working properly.{' '}
                        <Link to={path.PRIVACY_POLICY} className={s.link}>Privacy Policy</Link>
                    </p>

                    <div className={s.actions}>
                        <button type="button" className={classNames(s.btn, s.secondary)}
                                onClick={() => setShowPreferences(true)}>
                            Manage preferences
                        </button>
                        <button type="button" className={classNames(s.btn, s.secondary)} onClick={handleRejectAll}>
                            Reject all
                        </button>
                        <button type="button" className={classNames(s.btn, s.primary)} onClick={handleAcceptAll}>
                            Accept all
                        </button>
                    </div>
                </div>
            )}

            <PreferencesModal
                open={showPreferences}
                consent={consent}
                onClose={closePreferences}
                onSave={handleSave}
                onAcceptAll={handleAcceptAll}
                onRejectAll={handleRejectAll}
            />
        </>
    );
};

export default CookieConsent;
